export function ProactivenessIcon({ className }: { className?: string }) {
	return (
		<svg
			className={className}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<path d="M13.5 4H11C6.75736 4 4.63604 4 3.31802 5.31802C2 6.63604 2 8.75736 2 13C2 17.2426 2 19.364 3.31802 20.682C4.63604 22 6.75736 22 11 22C15.2426 22 17.364 22 18.682 20.682C20 19.364 20 17.2426 20 13V10.5" />
			<path d="M6 8L16 18" />
			<path d="M6 14L10 18" />
			<path d="M12 8L16 12" />
			<path d="M19.5 2.9375V4.5M19.5 4.5V6.0625M19.5 4.5H18.25M19.5 4.5H20.75M22 4.5L20.9156 4.13852C20.4179 3.97263 20.0274 3.58211 19.8615 3.08443L19.5 2L19.1385 3.08443C18.9726 3.58211 18.5821 3.97263 18.0844 4.13852L17 4.5L18.0844 4.86148C18.5821 5.02737 18.9726 5.41789 19.1385 5.91557L19.5 7L19.8615 5.91557C20.0274 5.41789 20.4179 5.02737 20.9156 4.86148L22 4.5Z" />
		</svg>
	)
}
